import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCurrent } from "../../hooks";
import { MwSpinnerButton } from "../ui";
import { getVendor } from "../../services/vendorService";
import { useTranslation } from "react-i18next";

const ShowVendor = () => {
  const params = useParams();
  const { currentLangId, currentTenantId } = useCurrent();
  const [vendor, setVendor] = useState();
  const [loading, setLoading] = useState(true);
  const [t] = useTranslation("global");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const data = await getVendor(
        currentTenantId,
        params.companyId,
        params.branchId,
        params.id
      );
      const fullname =
        data?.fullname?.find((item) => item.lang?.trim() === currentLangId)?.text ||
        data?.fullname?.[0]?.text ||
        "";
      setVendor({ ...data, name: fullname });
      setLoading(false);
    };
    load();
  }, [currentTenantId, params.companyId, params.branchId, params.id, currentLangId]);

  if (loading) {
    return (
      <div className="p-4">
        <MwSpinnerButton withLabel={false} isFullCenter={true} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="bg-slate-50 text-slate-500 rounded-lg p-3 text-xs">
        <div className="font-bold px-2 pt-3 text-sm text-center">{vendor?.name}</div>
        <div className="flex justify-between p-2">
          <span>{t("vendors.vendorNumber")}</span>
          <span>{vendor?.vendorNo || t("vendors.noData")}</span>
        </div>
        <hr />
        <div className="flex justify-between p-2">
          <span>{t("vendors.mobileNumber")}</span>
          <span>{vendor?.mobileNo || t("vendors.noData")}</span>
        </div>
        <hr />
        <div className="flex justify-between p-2">
          <span>{t("vendors.email")}</span>
          <span>{vendor?.email || t("vendors.noData")}</span>
        </div>
        <hr />
        <div className="flex justify-between p-2">
          <span>{t("vendors.notes")}</span>
          <span>{vendor?.notes || t("vendors.noData")}</span>
        </div>
      </div>
    </div>
  );
};

export default ShowVendor;
